import {FC, useState} from 'react'
import {useQuery} from 'react-query'
import {useNavigate} from 'react-router-dom'
import {getScheduledQuizzes, StudentScheduledQuizGroup} from '../core/_requests'
import {ClassesLoading} from '../../classes/components/ClassesLoading'
import {IClassQuiz, QuizAnswerStatusEnum} from '../../../models/IClassQuiz'
import {ClassQuizStartModal} from '../../classes/class-detail/components/ClassQuizStartModal'
import {KTIcon} from '../../../../_metronic/helpers'
import {useAuth} from '../../auth'
import {logoutExamAuth} from '../../auth/core/_requests'
import clsx from 'clsx'
import moment from 'moment'

const ExamQuizHome: FC = () => {
  const navigate = useNavigate()
  const {logout} = useAuth()
  const [selectedQuiz, setSelectedQuiz] = useState<IClassQuiz>()
  const [selectedClassId, setSelectedClassId] = useState<number>(0)
  const [showStartModal, setShowStartModal] = useState(false)

  const {data, isFetching} = useQuery(['exam-scheduled-quizzes'], () => getScheduledQuizzes(), {
    cacheTime: 0,
  })

  const groups: StudentScheduledQuizGroup[] = data?.data ?? []

  const handleLogout = async () => {
    try {
      await logoutExamAuth()
    } finally {
      logout()
      navigate('/auth/exam')
    }
  }

  const handleStartQuiz = (classId: number, item: IClassQuiz) => {
    if (item.answerStatusId === +QuizAnswerStatusEnum.Processed) {
      navigate(`/exam-login/quiz/${item.id}?cid=${classId}`)
      return
    }
    setSelectedClassId(classId)
    setSelectedQuiz(item)
    setShowStartModal(true)
  }

  const handleModalClose = (start: boolean) => {
    if (start && selectedQuiz) {
      navigate(`/exam-login/quiz/${selectedQuiz.id}?cid=${selectedClassId}`)
    }
    setSelectedQuiz(undefined)
    setShowStartModal(false)
  }

  return (
    <div className='container py-10'>
      <div className='d-flex justify-content-between align-items-center mb-8'>
        <div>
          <h1 className='page-heading text-dark fw-bold fs-2 my-0'>Daftar Quiz</h1>
          <div className='text-muted fs-7'>Semester berjalan — semua jenis quiz terjadwal</div>
        </div>
        <button type='button' className='btn btn-light-danger btn-sm' onClick={handleLogout}>
          Keluar
        </button>
      </div>

      {isFetching ? (
        <ClassesLoading />
      ) : groups.length === 0 ? (
        <div className='alert alert-warning'>Belum ada quiz terjadwal untuk kelas Anda.</div>
      ) : (
        groups.map((group) => (
          <div key={group.classId} className='card mb-6'>
            <div className='card-header'>
              <h3 className='card-title'>{group.courseName ?? group.className}</h3>
              <span className='text-muted fs-7'>{group.className}</span>
            </div>
            <div className='card-body p-0'>
              <div className='table-responsive'>
                <table className='table table-row-bordered align-middle gs-0 gy-4 mb-0'>
                  <thead>
                    <tr className='fw-bold text-muted'>
                      <th>Quiz</th>
                      <th>Jadwal</th>
                      <th className='text-end'>Aksi</th>
                    </tr>
                  </thead>
                  <tbody>
                    {group.quizzes.map((quiz) => (
                      <tr key={quiz.id}>
                        <td>
                          <span className='fw-bold text-gray-800'>{quiz.name}</span>
                          {quiz.isExam && (
                            <span className='badge badge-light-danger ms-2'>Ujian</span>
                          )}
                        </td>
                        <td>
                          {quiz.startDate
                            ? moment(quiz.startDate).format('DD/MM/YYYY HH:mm')
                            : '-'}
                          {quiz.endDate ? ` — ${moment(quiz.endDate).format('DD/MM/YYYY HH:mm')}` : ''}
                        </td>
                        <td className='text-end'>
                          <button
                            type='button'
                            className={clsx('btn btn-sm', quiz.isCanStart ? 'btn-warning' : 'btn-light')}
                            disabled={!quiz.isCanStart}
                            onClick={() => handleStartQuiz(group.classId, quiz)}
                          >
                            <KTIcon iconName='entrance-right' className='fs-3' />
                            {quiz.answerStatusId === +QuizAnswerStatusEnum.Processed
                              ? 'Lanjut'
                              : 'Mulai'}
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        ))
      )}

      {showStartModal && selectedQuiz && (
        <ClassQuizStartModal
          show={showStartModal}
          quiz={selectedQuiz}
          onClose={handleModalClose}
        />
      )}
    </div>
  )
}

export {ExamQuizHome}
